import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import PopupModal from './PopupModel';
import { sessionTimeoutConfig } from "../../config/sessionTimeoutConfig"

const SessionTimeout = () => {
    const [isActive, setIsActive] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const timeoutIdRef = useRef(null);
    const { accounts } = useMsal();

    const resetTimeout = useCallback(() => {
        clearTimeout(timeoutIdRef.current);
        const newTimeoutId = setTimeout(() => handleTimeout(), sessionTimeoutConfig.sessionDurationTime);
        timeoutIdRef.current = newTimeoutId;
    }, []);

    const handleRenewal = useCallback(() => {
        setIsActive(true);
        resetTimeout();
        setShowPopup(false);
        // window.location.reload();
    }, [resetTimeout]);


    const handleTimeout = () => {
        setIsActive(false);
        setShowPopup(true);
    };

    const handleUserActivity = () => {
        if (isActive) {
            resetTimeout();
            setShowPopup(false);
        }
    };

    useEffect(() => {
        resetTimeout();

        document.addEventListener('mousemove', handleUserActivity);
        document.addEventListener('keydown', handleUserActivity);

        return () => {
            clearTimeout(timeoutIdRef.current);
            document.removeEventListener('mousemove', handleUserActivity);
            document.removeEventListener('keydown', handleUserActivity);
        };
    }, [isActive, resetTimeout]);

    const isLoginPage = window.location.pathname === "/";

    return (
        <div>
            {!isLoginPage && (
                <>

                    {showPopup && (
                        <PopupModal onRenew={handleRenewal} showModal={showPopup} setShowModal={setShowPopup} />
                    )}
                </>
            )}
        </div>
    );
};

export default SessionTimeout;
